import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner container">
        <div className="footer-brand">
          <div className="footer-logo">🌿 PlantShop</div>
          <p>India's most loved destination for plants, pots, and gardening essentials. Bringing greenery to every home.</p>
        </div>

        <div className="footer-col">
          <h4>Shop</h4>
          <Link to="/shop?category=indoor-plants">Indoor Plants</Link>
          <Link to="/shop?category=outdoor-plants">Outdoor Plants</Link>
          <Link to="/shop?category=succulents">Succulents</Link>
          <Link to="/shop?category=herbs">Herbs</Link>
          <Link to="/shop?category=tools">Garden Tools</Link>
        </div>

        <div className="footer-col">
          <h4>Account</h4>
          <Link to="/profile">My Profile</Link>
          <Link to="/orders">My Orders</Link>
          <Link to="/wishlist">Wishlist</Link>
          <Link to="/cart">Shopping Cart</Link>
        </div>

        <div className="footer-col">
          <h4>Support</h4>
          <a href="mailto:support@plantshop.com">support@plantshop.com</a>
          <p>Mon–Sat, 9 AM – 6 PM IST</p>
          <p>📞 +91 98765 43210</p>
          <p style={{ marginTop: 10 }}>We accept:</p>
          <div className="payment-icons">
            <span>💳</span><span>🇮🇳 UPI</span><span>🏦 Netbanking</span>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>© {new Date().getFullYear()} PlantShop. All rights reserved. Made with 🌿 in India.</p>
          <div className="footer-bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms of Service</a>
            <a href="#returns">Return Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
